import * as firebaseui from "firebaseui";
import * as firebase from "firebase";

import { environment } from "../../../environments/environment";
import {
  AfterViewInit,
  Component,
  ElementRef,
  ViewChild,
  OnInit,
  NgZone,
} from "@angular/core";
import { FirebaseService } from "../../services/firebase.service";
import { Router, ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.less", "../../../assets/style.less"],
})
export class LoginComponent implements OnInit {
  ui: firebaseui.auth.AuthUI;

  companyName: String;

  // The Url to navigate to after the user has logged in
  returnUrl: string;

  @ViewChild("authContainer") firebaseAuthContainer: ElementRef;

  constructor(
    private firebaseService: FirebaseService,
    private route: Router,
    private router: ActivatedRoute,
    private ngZone: NgZone,
    private activatedRoute: ActivatedRoute
  ) {
    this.ui =
      firebaseui.auth.AuthUI.getInstance() ||
      new firebaseui.auth.AuthUI(firebase.auth());
  }

  ngAfterViewInit() {
    this.startSignIn();
  }

  ngOnInit() {
    this.returnUrl = this.router.snapshot.queryParams["returnUrl"] || "/";
  }

  saveCustomer(authResult) {}

  getConfig() {
    var uiConfig = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          // User successfully signed in.
          // Return type determines whether we continue the redirect automatically
          // or whether we leave that to developer to handle.
          let user = authResult.user;
          this.firebaseService.createCustomer(
            user.email,
            user.displayName,
            user.uid
          );

          this.ngZone.run(() => {
            // When navigating within callbacks from external js code not related to angular,
            // you'll get an error that a navigation was triggered outside of the angular zone
            // This is why this navigation is wrapped within this ngZone.run() call
            // For more information see @albanx answer on stack overflow at:
            // https://stackoverflow.com/questions/53645534/navigation-triggered-outside-angular-zone-did-you-forget-to-call-ngzone-run
            this.route.navigateByUrl(this.returnUrl);
          });

          return false;
        },
        uiShown: function () {
          // The widget is rendered.
          // Hide the loader.
          document.getElementById("loader").style.display = "none";
        },
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: "popup",
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
      ],
      // Terms of service url.
      tosUrl:
        "https://app.termly.io/document/terms-of-use-for-website/5e9e6606-5971-410e-8ed3-bd8f0beece8e",
      // Privacy policy url.
      privacyPolicyUrl:
        "https://app.termly.io/document/privacy-policy/2e1f24f7-8436-40dc-b16f-224e57b8a320",
    };

    return uiConfig;
  }

  /**
   * Kick off the sign in authentication
   */
  startSignIn() {
    this.ui.start(this.firebaseAuthContainer.nativeElement, this.getConfig());
  }
}
